/**
 * @file Account related mutations.
 */

import gql from 'graphql-tag';

import {
  IdentityDetails,
  AccountIdentityName,
  IdentityDetailsBase,
  IdentityJoinedAlbums,
  IdentityDetailsWithPurchasedAlbumFolders,
} from '../fragments/identity';

export const identityCreate = gql`
  mutation identityCreate($input: CreateIdentityInput!) {
    identityCreate(input: $input) {
      identity {
        ...IdentityDetailsBase
        ...IdentityJoinedAlbums
        ...IdentityDetailsWithPurchasedAlbumFolders
      }
    }
  }
  ${IdentityDetailsBase}
  ${IdentityJoinedAlbums}
  ${IdentityDetailsWithPurchasedAlbumFolders}
`;

export const updateSelfie = gql`
  mutation updateSelfie($input: UpdateSelfieInput!) {
    updateSelfie(input: $input) {
      identity {
        ...IdentityDetailsBase
        ...IdentityJoinedAlbums
        ...IdentityDetailsWithPurchasedAlbumFolders
      }
    }
  }
  ${IdentityDetailsBase}
  ${IdentityJoinedAlbums}
  ${IdentityDetailsWithPurchasedAlbumFolders}
`;

export const selectedIdentityUpdate = gql`
  mutation selectedIdentityUpdate($input: SelectedIdentityUpdateInput!) {
    selectedIdentityUpdate(input: $input) {
      selected_identity {
        id
        cabin_name
        jersey_number
        school_class
      }
    }
  }
`;

export const setAccountIdentityName = gql`
  mutation setAccountIdentityName($input: SetAccountIdentityNameInput!) {
    setAccountIdentityName(input: $input) {
      account_identity_name {
        id
        name
        identity {
          id
          ...AccountIdentityName
        }
      }
    }
  }
  ${AccountIdentityName}
`;

export const identitySharesCreate = gql`
  mutation identitySharesCreate($input: IdentitySharesCreateInput!) {
    identitySharesCreate(input: $input) {
      success
    }
  }
`;

export const identityShareAccept = gql`
  mutation identityShareAccept($input: IdentityShareAcceptInput!) {
    identityShareAccept(input: $input) {
      success
      identity_share {
        id
        status
        identity {
          ...IdentityDetails
          ...IdentityJoinedAlbums
          ...IdentityDetailsWithPurchasedAlbumFolders
        }
      }
    }
  }
  ${IdentityDetails}
  ${IdentityJoinedAlbums}
  ${IdentityDetailsWithPurchasedAlbumFolders}
`;

export const identityShareReject = gql`
  mutation identityShareReject($input: IdentityShareRejectInput!) {
    identityShareReject(input: $input) {
      success
      identity_share {
        id
        status
        identity {
          ...IdentityDetails
          ...IdentityJoinedAlbums
          ...IdentityDetailsWithPurchasedAlbumFolders
        }
      }
    }
  }
  ${IdentityDetails}
  ${IdentityJoinedAlbums}
  ${IdentityDetailsWithPurchasedAlbumFolders}
`;
